import storage from 'redux-persist/lib/storage';
import { LOGIN } from 'src/app/router/constant/ROUTE';
import history from 'src/app/router/utils/history';
import { clearCookies } from 'src/helper/utilityFunctions';

import { logoutUser } from '../../redux/store/actionCreator';
import store from '../../redux/store/index';
import i18n from '../i18next';

export default function LogoutRedux() {
  // Remove all keys defined in persistConfig(s) of `redux-persist` (to make sure `store` does not get rehydrated after page refresh)
  clearCookies?.();
  //Reset i18language to English to make login page consistency
  i18n.changeLanguage('en');

  storage.removeItem('persist:root');

  localStorage.clear();

  // Reset Redux store to its initial state
  store.dispatch(logoutUser());

  // Redirect the user to login screen
  history.push(LOGIN);
}
